module.exports = __webpack_public_path__ + "img/24.90989430.png";